<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-canned-response-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="loading" class="table__no-items">Loading canned response details...</div>

    <ng-container *ngIf="!loading && ruleSetData">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <h2 fxFlex class="nomargin input__editable">
          <input
            #nameInput
            class="input__borderless"
            type="text"
            [style.width.px]="nameInput.value.length * 13"
            [(ngModel)]="ruleSetData.name"
            (change)="updateRuleSet()" />
        </h2>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable">
            <sbnb-icon icon="message" class="text-smoke-darker"></sbnb-icon>
            <span>Message</span>
            <span fxHide.lt-md class="card__collapsed-helper-text">
              The message that will be sent to your guest. You can use short codes and custom codes by typing %.
            </span>
          </h3>
        </div>

        <div>
          <sbnb-rule-editor
            [ruleSetId]="ruleSetId"
            [importEnabled]="true"
            (saveStatusChange)="ruleSaveStatusChange($event)"></sbnb-rule-editor>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
            <span class="card__collapsed-helper-text">Limit the usage of this rule with the options below.</span>
          </h3>
        </div>

        <div>
          <sbnb-rule-scope [initial]="ruleSetData" (completed)="handleScopeChange($event)"></sbnb-rule-scope>
        </div>
      </div>

      <div class="rule__section-container" fxLayout>
        <div fxFlex fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <sbnb-button
            label="Delete"
            icon="delete"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="deleteRulesetPrompt()"></sbnb-button>

          <sbnb-button
            label="Copy"
            icon="copy"
            type="text"
            [labelColor]="'#ED3C6A'"
            (clicked)="copyRuleset()"></sbnb-button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
